// extracted by mini-css-extract-plugin
export default {"underlined":"Style_underlined__alwCV"};